export default __webpack_public_path__ + "_/images/referrals/icon-gift-63f0c865cd34575cec0b211025e8e9304c448241e1a3b06243f68a82d29d47ae.png";